import { useSelector, useDispatch } from "react-redux";
import { useEffect, useMemo } from "react";
import { hasCheckSecurity } from "@/util/common_function";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import { setUserSecurityUpdated } from "@/slices/userDetailDetail";

const ALWAYS_ALLOWED_KEYS = [
  "dashboard",
  "bookings",
  "users",
  "warrants"
];

export const getAllowedMenu = (menuList = []) => {
  const dispatch = useDispatch();
  // console.log("Get Allowed Menu")
  const { userDetail, userSecurityUpdated } = useSelector(
    (state) => state.userDetail
  );
  // console.log(userDetail)
  // console.log(userSecurityUpdated)
  // When userDetail arrives → mark security updated ONCE
  useEffect(() => {
    // console.log("Effect running:", userDetail, userSecurityUpdated);
    if (userDetail?.staffId && !userSecurityUpdated) {
      dispatch(setUserSecurityUpdated(true));
    }
  }, [userDetail, userSecurityUpdated, dispatch]);
  // console.log(userSecurityUpdated)
  // Compute menu only when userDetail or menuList changes
  const finalMenu = useMemo(() => {
    if (!userDetail) return [];

    let securityAllowed = [];

    const localData = localStorage.getItem("allowedMenu");

    if (localData) {
      try {
        const parsed = JSON.parse(localData);
        if (Array.isArray(parsed)) {
          securityAllowed = parsed;
        }
      } catch {
        localStorage.removeItem("allowedMenu");
      }
    }

    if (securityAllowed.length === 0) {
      securityAllowed = menuList.filter(item =>
        hasCheckSecurity(
          Security_Types.functionality,
          Entity_types.module,
          LABELS_CAPITAL.VIEW,
          item.label
        )
      );

      localStorage.setItem("allowedMenu", JSON.stringify(securityAllowed));
    }

    const alwaysAllowedModules = menuList.filter(item =>
      ALWAYS_ALLOWED_KEYS.includes(item.key)
    );

    const finalList = [
      ...alwaysAllowedModules,
      ...securityAllowed.filter(
        x => !ALWAYS_ALLOWED_KEYS.includes(x.key)
      ),
    ];

    return finalList.sort((a, b) => a.label.localeCompare(b.label));
  }, [userDetail, menuList]);

  return finalMenu;
};
